<template>
    <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no">
    </meta>
    <div class="home-page">
        <!-- 页面主要内容区域 -->
        <main class="main-content">
            <!-- 轮播图板块 -->
            <div class="carousel-section">
                <el-carousel :height="carouselHeight" motion-blur class="carousel-section">
                    <el-carousel-item v-for="item in Items" :key="item.id">
                        <div :style="`background-image: url(${item.image});`" class="carousel-image">
                            <div class="carousel-title" v-html="item.title"></div>
                            <div class="carousel-text">{{ item.text }}</div>
                            <div class="carousel-des">{{ item.des }}</div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <!-- 关于我们板块 -->
            <div class="title-main" ref="sectionSectionRef">
                <div class="title-section" :class="{ 'slide-in-left': sectionVisible }">
                    <p class="section-description">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="color: #3773f5;">佛山市势联出海合规进出口服务有限公司</span>是首家专注于跨境电商领域，为进出口商家搭建跨境全链路合规渠道，赋能商家完成进出口资质、商务、关务、财务、税务、法务、技术、金融等全方位合规工作的落地服务单位。
                    </p>
                    <p class="section-description">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;承接众多跨境电商企业的合规部门整合外包、单证规范和外综服代理等需求，为其构建合规转型框架，实现增本增效。
                    </p>
                </div>
                <img src="https://www.sailortrade.top/imgs/sailor.webp" class="section-img"
                    :class="{ 'slide-in-right': sectionVisible }">
            </div>
            <!-- 三大宗旨板块 -->
            <div class="features-section" ref="featureSectionRef">
                <div class="features-container">
                    <div class="feature-item" :class="{ 'slide-in-left': featuresVisible }">
                        <div class="feature-title">使命</div>
                        <div class="feature-content">赋能中国品牌</div>
                        <div class="feature-content">深耕全球落地发展</div>
                    </div>
                    <div class="divier-row"></div>
                    <div class="feature-item" :class="{ 'slide-in-right': featuresVisible }">
                        <div class="feature-title">价值观</div>
                        <div class="feature-content">专业护航出海</div>
                        <div class="feature-content">诚信链接全球机遇</div>
                    </div>
                    <div class="divier-row"></div>
                    <div class="feature-item" :class="{ 'slide-in-left': featuresVisible }">
                        <div class="feature-title">愿景</div>
                        <div class="feature-content">助力品牌出海</div>
                        <div class="feature-content">勇当领航战略伙伴</div>
                    </div>
                </div>
            </div>
            <!-- 数据列表板块 -->
            <div class="data-section" ref="dataSectionRef">
                <div>
                    <p class="data-title">服务中国企业</p>
                    <p class="data-title">累计申报出口额达到10亿+</p>
                </div>
                <div class="data-main">
                    <div class="data-card">
                        <div class="data-count">
                            <el-statistic :value="qiyeValue" />
                            <span class="data-unit">家+</span>
                        </div>
                        <p class="data-des">累计服务企业</p>
                    </div>
                    <div class="data-card">
                        <div class="data-count">
                            <el-statistic :value="baoguanValue" />
                            <span class="data-unit">万+</span>
                        </div>
                        <p class="data-des">年均报关票数</p>
                    </div>
                    <div class="data-card">
                        <div class="data-count">
                            <el-statistic :value="tuishuiValue" />
                            <span class="data-unit">万+</span>
                        </div>
                        <p class="data-des">累计申报退税额</p>
                    </div>
                    <div class="data-card">
                        <div class="data-count">
                            <el-statistic :value="chukouValue" />
                            <span class="data-unit">亿+</span>
                        </div>
                        <p class="data-des">累计申报出口额</p>
                    </div>
                </div>
            </div>
            <!-- 企业自营出口全链路运营板块 -->
            <div class="scrolling-images-section" ref="serverSection">
                <div class="scrolling-title" :class="{ 'slide-up': serverSectionVisible }">企业自营出口全链路运营</div>
                <div class="divier-column" :class="{ 'slide-up': serverSectionVisible }"></div>
                <p class="scrolling-en" :class="{ 'slide-up': serverSectionVisible }">Enterprise Self-operated Export
                    Full-chain Operation</p>
                <div class="proservice-column">
                    <div class="proservice-item" v-for="(item, index) in imageList1" :key="index"
                        :class="{ 'slide-up': serverSectionVisible }">
                        <img :src="item.image" :alt="item.description" class="scrolling-image">
                        <div class="scrolling-card">
                            <div class="image-title">
                                <div class="image-zh">{{ item.zh }}</div>
                                <div class="image-en">{{ item.en }}</div>
                            </div>
                        </div>
                        <div class="image-description">{{ item.description }}</div>
                    </div>
                </div>
                <div class="proservice-column">
                    <div class="proservice-item" v-for="(item, index) in imageList2" :key="index"
                        :class="{ 'slide-up': serverSectionVisible }">
                        <img :src="item.image" :alt="item.description" class="scrolling-image">
                        <div class="scrolling-card">
                            <div class="image-title">
                                <div class="image-zh">{{ item.zh }}</div>
                                <div class="image-en">{{ item.en }}</div>
                            </div>
                        </div>
                        <div class="image-description">{{ item.description }}</div>
                    </div>
                </div>
            </div>
            <!-- 全代码双抬头省心代理 -->
            <div class="agent-section" ref="agentSectionRef" :class="{ 'slide-up': agentVisible }">
                <div class="agent-title">全代码双抬头省心代理</div>
                <div class="divier-column" :class="{ 'slide-up': agentVisible }"></div>
                <div class="agent-en">Full-code Dual-heading Hassle-free Proxy</div>
                <div class="agent-main">
                    <div class="agent-column" :class="{ 'slide-up': agentVisible }">
                        <div class="agent-t">一般贸易</div>
                        <div class="agent-s">传统贸易代理/工厂代办退税/外贸展会资源/境内外展厅资源/海外社媒询盘</div>
                        <img src="https://www.sailortrade.top/imgs/agent1.webp" alt="" class="agent-img">
                    </div>
                    <div class="agent-column" :class="{ 'slide-up': agentVisible }">
                        <div class="agent-t">跨境电商</div>
                        <div class="agent-s">9610-9710-9810全电商代码代理/申报代理出口证明/跨境店群卖家福音</div>
                        <img src="https://www.sailortrade.top/imgs/agent2.webp" alt="" class="agent-img">
                    </div>
                    <div class="agent-column" :class="{ 'slide-up': agentVisible }">
                        <div class="agent-t">市场采购</div>
                        <div class="agent-s">1039市场采购模式/园区个体户注册开户/无票采购报关/核定征收完税证明</div>
                        <img src="https://www.sailortrade.top/imgs/agent3.webp" alt="" class="agent-img">
                    </div>
                </div>
            </div>
            <!-- 出海企业专项资源服务 -->
            <div class="specialized-section" ref="foreignPointSectionRef" :class="{ 'slide-up': foreignPointVisible }">
                <div class="specialized-title">出海企业专项资源服务</div>
                <div class="divier-column" :class="{ 'slide-up': foreignPointVisible }"></div>
                <div class="specialized-en">Specialized Resource Services for Cross Border Enterprises Entarnricace
                </div>
                <div class="hover-content-section">
                    <!-- 导航按钮区域 -->
                    <div class="nav-buttons">
                        <div v-for="(item, index) in contentList" :key="index" class="nav-button"
                            :class="{ 'active': activeIndex === index }" @mouseenter="handleMouseEnter(index)">
                            {{ item.title }}
                        </div>
                    </div>
                    <!-- 内容展示区域 -->
                    <div class="content-area">
                        <div v-for="(item, index) in contentList" :key="index" class="content-item"
                            :class="{ 'active': activeIndex === index }">
                            <div class="content-main">
                                <img :src="item.img" class="content-img">
                                <div class="content-details">
                                    <div class="content-title">{{ item.title }}</div>
                                    <ul>
                                        <li v-for="(detail, detailIndex) in item.details" :key="detailIndex"
                                            class="content-detail">
                                            <div class="detail-text">{{ detail }}</div>
                                        </li>
                                    </ul>
                                    <div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- X-Sailor智能单证系统全面科技助力板块 -->
            <div class="paltform-content" :class="{ 'visible': paltformVisible }" ref="paltformSectionRef">
                <div class="paltform-title">X-Sailor智能单证系统全面科技助力</div>
                <div class="divier-column"></div>
                <div class="paltform-en">System Platform Introduction</div>
                <div class="paltform-main">
                    <div class="paltform-card">
                        <img src="../../../assets/image/pingtai1.webp" alt="" class="paltform-img">
                        <div class="paltform-text-left">
                            <div class="paltform-des">支持0110/9610/9710/9810/1039全跨境代码</div>
                            <div class="paltform-des">打通出口环节全信息壁垒</div>
                            <div class="paltform-des">单证电子化存储及合规管控</div>
                        </div>
                    </div>
                    <div class="paltform-card1">
                        <div class="paltform-text-right">
                            <div class="paltform-des">关汇税单证业务全托管</div>
                            <div class="paltform-des">完美替代关务和财税团队</div>
                            <div class="paltform-des">进出口单证精准校验流转</div>
                        </div>
                        <img src="https://www.sailortrade.top/imgs/pingtai2.webp" alt="" class="paltform-img-height">
                    </div>
                </div>
            </div>
            <!-- 解决痛点 -->
            <div class="foreign-content" :class="{ 'visible': foreignVisible }" ref="foreignSectionRef">
                <div class="foreign-point">
                    <div class="foreign-title">解决痛点</div>
                    <div class="divier-column" :class="{ 'slide-up': foreignPointVisible }"></div>
                    <div class="foreign-en">Address Pain Points</div>
                    <!-- 移动端和桌面端分别显示不同的图片 -->
                    <img src="https://www.sailortrade.top/imgs/middle.webp" alt=""
                        class="foreign-center-img desktop-img" :class="{ 'slide-up': foreignPointVisible }">
                    <img src="@/assets/image/point.webp" alt="" class="foreign-center-img mobile-img">
                    <div class="foreign-item1">
                        <div class="foreign-item-title">
                            <span class="foreign-item-num">01</span>
                            买单报关出口
                        </div>
                        <img src="https://www.sailortrade.top/imgs/point1.webp" alt="" class=foreign-point-img>
                    </div>
                    <div class="foreign-item2">
                        <div class="foreign-item-title">
                            <span class="foreign-item-num">02</span>
                            违规收款
                        </div>
                        <img src="https://www.sailortrade.top/imgs/point2.webp" alt="" class=foreign-point-img>
                    </div>
                    <div class="foreign-item3">
                        <div class="foreign-item-title">
                            <span class="foreign-item-num">03</span>
                            无法申请补贴
                        </div>
                        <img src="https://www.sailortrade.top/imgs/point3.webp" alt="" class=foreign-point-img>
                    </div>
                    <div class="foreign-item4">
                        <div class="foreign-item-title">
                            <span class="foreign-item-num">04</span>
                            缺乏税务筹划
                        </div>
                        <img src="https://www.sailortrade.top/imgs/point4.webp" alt="" class=foreign-point-img>
                    </div>
                    <div class="foreign-item5">
                        <div class="foreign-item-title">
                            <span class="foreign-item-num">05</span>
                            报关效率低
                        </div>
                        <img src="https://www.sailortrade.top/imgs/point5.webp" alt="" class=foreign-point-img>
                    </div>
                    <div class="foreign-item6">
                        <div class="foreign-item-title">
                            <span class="foreign-item-num">06</span>
                            无票采购
                        </div>
                        <img src="https://www.sailortrade.top/imgs/point6.webp" alt="" class=foreign-point-img>
                    </div>
                </div>
            </div>
            <!-- 优势板块 -->
            <div class="advantage-content">
                <div class="advantage-title">我们的优势</div>
                <div class="divier-column"></div>
                <div class="advantage-en">Our Advantages</div>
                <div class="advantage-main">
                    <div class="advantage-column">
                        <img src="@/assets/image/youshi1.svg" alt="" class="advantage-img">
                        <div class="advantage-info">
                            <div class="advantage-text">全链路能力</div>
                            <div class="advantage-des">资质、关务、财务、税务、法务、技术6大模块全覆盖，避免多服务商对接的繁琐与风险漏洞</div>
                        </div>
                    </div>
                    <div class="advantage-column">
                        <img src="@/assets/image/youshi2.svg" alt="" class="advantage-img">
                        <div class="advantage-info">
                            <div class="advantage-text">政企资源整合</div>
                            <div class="advantage-des">与海关、税务、商务等部门深度合作，与知名律所、会计师事务所、技术公司共建生态，确保服务权威性</div>
                        </div>
                    </div>
                    <div class="advantage-column">
                        <img src="@/assets/image/youshi3.svg" alt="" class="advantage-img">
                        <div class="advantage-info">
                            <div class="advantage-text">双场景经验</div>
                            <div class="advantage-des">既懂跨境商家一线运营痛点，又熟园区服务体系搭建逻辑，服务更贴合实际需求</div>
                        </div>
                    </div>
                    <div class="advantage-column">
                        <img src="@/assets/image/youshi4.svg" alt="" class="advantage-img">
                        <div class="advantage-info">
                            <div class="advantage-text">数字化支撑</div>
                            <div class="advantage-des">自主研发合规管理系统，实现服务流程可视化、数据化，提升效率与透明度</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 服务流程板块 -->
            <div class="server-main" ref="serverSectionRef">
                <div class="server-title">服务流程</div>
                <div class="divier-column"></div>
                <p class="server-en">Service Process</p>
                <div class="server-conter">
                    <div class="server-card" :class="{ 'slide-up': serverVisible }">
                        <img src="@/assets/image/ask.svg" class="server-icon" :class="{ 'slide-up': serverVisible }">
                        <div class="server-text" :class="{ 'slide-up': serverVisible }">顾问团队前期业务沟通</div>
                    </div>
                    <img src="@/assets/image/pointer.svg" class="server-icon" :class="{ 'slide-up': serverVisible }">
                    <div class="server-card" :class="{ 'slide-up': serverVisible, 'delay-1': true }">
                        <img src="@/assets/image/call.svg" class="server-icon" :class="{ 'slide-up': serverVisible }">
                        <div class="server-text" :class="{ 'slide-up': serverVisible }">结合企业实务分析合规需求</div>
                    </div>
                    <img src="@/assets/image/pointer.svg" class="server-icon"
                        :class="{ 'slide-up': serverVisible, 'delay-2': true }">
                    <div class="server-card" :class="{ 'slide-up': serverVisible, 'delay-3': true }">
                        <img src="@/assets/image/edit.svg" class="server-icon" :class="{ 'slide-up': serverVisible }">
                        <div class="server-text" :class="{ 'slide-up': serverVisible }">定制合规运营解决方案</div>
                    </div>
                    <img src="@/assets/image/pointer.svg" class="server-icon"
                        :class="{ 'slide-up': serverVisible, 'delay-4': true }">
                    <div class="server-card" :class="{ 'slide-up': serverVisible, 'delay-5': true }">
                        <img src="@/assets/image/home.svg" class="server-icon" :class="{ 'slide-up': serverVisible }">
                        <div class="server-text" :class="{ 'slide-up': serverVisible }">方案成功落地走通首单业务</div>
                    </div>
                    <img src="@/assets/image/pointer.svg" class="server-icon"
                        :class="{ 'slide-up': serverVisible, 'delay-6': true }">
                    <div class="server-card" :class="{ 'slide-up': serverVisible, 'delay-7': true }">
                        <img src="@/assets/image/ship.svg" class="server-icon" :class="{ 'slide-up': serverVisible }">
                        <div class="server-text" :class="{ 'slide-up': serverVisible }">协助日常出货关汇税运营</div>
                    </div>
                </div>
            </div>
            <!-- 项目经验 -->
            <div class="experience-content">
                <div class="experience-title">项目经验</div>
                <div class="divier-column"></div>
                <div class="experience-en">Project Experience</div>
                <div class="scrolling-container-css">
                    <div class="scrolling-track">
                        <div class="scrolling-item" v-for="(item, index) in extendedExperienceList" :key="index"
                            style="width: 280px;">
                            <div class="scrolling-card">
                                <img :src="item.image" class="scrolling-image" style="height: 150px; width: 280px;">
                                <div class="experience-text">{{ item.text }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 监管资源板块 -->
            <div class="source-section" ref="sourceSection">
                <div class="scrolling-title">监管资源</div>
                <div class="divier-column"></div>
                <p class="scrolling-en">Compliance Resources</p>
                <div class="scrolling-container-css">
                    <div class="scrolling-track">
                        <div class="scrolling-item" v-for="(item, index) in extendedSourceList" :key="index"
                            style="width: 280px;">
                            <div class="scrolling-card">
                                <img :src="item.image" class="scrolling-image" style="height: 150px; width: 280px;">
                                <div class="image-des">{{ item.description }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 优秀案例板块 -->
            <div class="case-content">
                <div class="case-title">优秀案例</div>
                <div class="divier-column"></div>
                <div class="case-en">Excellent Case</div>
                <div class="case-main">
                    <el-carousel :interval="3000" type="card" indicator-position="outside" class="case-carousel">
                        <el-carousel-item v-for="(item, index) in caseList" :key="index">
                            <img :src="item.image" class="case-img">
                            <div class="case-item-title">
                                {{ item.title }}
                                <div class="case-text">
                                    <div>{{ item.text }}</div>
                                    <div>{{ item.des }}</div>
                                </div>
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
            <!-- 活动资讯模块 -->
            <div class="activity-content">
                <div class="activity-title">活动资讯</div>
                <div class="divier-column"></div>
                <div class="activity-en">Event Information</div>
                <div class="activity-main">
                    <div v-for="(card, index) in activityCards" :key="card.id"
                        :class="['activity-card', { 'active': index === activeCardIndex, 'transitioning': isTransitioning }]"
                        v-show="index === activeCardIndex">
                        <img :src="card.image" :alt="card.title" class="activity-img"></img>
                        <div class="activity-text">
                            <div class="activity-h1">{{ card.title }}</div>
                            <div class="activity-des">{{ card.description }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 侧边组件 -->
            <div class="groupTools">
                <div class="to_top" @click.prevent="goToTop">
                    <img src="@/assets/image/up.png" class="to_top_img">
                </div>
            </div>
        </main>
    </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useTransition } from '@vueuse/core';
const goToTop = () => {
    scrollToElement('.main-content');
};
// Vue 3 组合式 API 实现滚动到元素的方法
const scrollToElement = (selector) => {
    // 使用 document.querySelector 查找元素
    const element = document.querySelector(selector);
    if (element) {
        element.scrollIntoView({
            behavior: 'smooth'
        });
    } else {
        console.warn(`Element with selector "${selector}" not found`);
    }
};
const qiyesource = ref(0)
const baoguansource = ref(0)
const tuishuisource = ref(0)
const chukousource = ref(0)
const qiyeValue = useTransition(qiyesource, {
    duration: 1600,
})
const baoguanValue = useTransition(baoguansource, {
    duration: 1200,
})
const tuishuiValue = useTransition(tuishuisource, {
    duration: 2000,
})
const chukouValue = useTransition(chukousource, {
    duration: 800,
})

// 控制数据是否开始加载的标志
const shouldLoadData = ref(false)
// Intersection Observer 实例引用
const observer = ref(null)
const featuresObserver = ref(null)
const foreignObserver = ref(null)
const paltformObserver = ref(null)
const sectionObserver = ref(null)
const serverSectionObserver = ref(null)
const serverObserver = ref(null)
const agentObserver = ref(null)
const foreignPointObserver = ref(null)
// 数据区域DOM引用
const dataSectionRef = ref(null)
const featureSectionRef = ref(null)
const foreignSectionRef = ref(null)
const paltformSectionRef = ref(null)
const sectionSectionRef = ref(null)
const serverSection = ref(null)
const serverSectionRef = ref(null)
const agentSectionRef = ref(null)
const foreignPointSectionRef = ref(null)
// 控制板块动画状态的响应式变量
const featuresVisible = ref(false)
const foreignVisible = ref(false)
const paltformVisible = ref(false)
const serverSectionVisible = ref(false)
const sectionVisible = ref(false)
const serverVisible = ref(false)
const agentVisible = ref(false)
const foreignPointVisible = ref(false)
// 当数据区域进入视口时触发的回调函数
const handleIntersection = (entries) => {
    const entry = entries[0]
    if (entry.isIntersecting) {
        // 当元素进入视口时，设置shouldLoadData为true以开始加载数据
        shouldLoadData.value = true

        // 启动数字动画
        qiyesource.value = 1000
        baoguansource.value = 200
        tuishuisource.value = 5000
        chukousource.value = 50

        // 加载后取消观察
        if (observer.value && dataSectionRef.value) {
            observer.value.unobserve(dataSectionRef.value)
        }
    }
}
// 宏观板块进入视口时的回调函数
const handleFeaturesIntersection = (entries) => {
    const entry = entries[0]
    if (entry.isIntersecting) {
        featuresVisible.value = true

        // 加载后取消观察
        if (featuresObserver.value && featureSectionRef.value) {
            featuresObserver.value.unobserve(featureSectionRef.value)
        }
    }
}

// 外贸凭证板块进入视口时的回调函数
const handleForeignIntersection = (entries) => {
    const entry = entries[0]
    if (entry.isIntersecting) {
        foreignVisible.value = true

        // 加载后取消观察
        if (foreignObserver.value && foreignSectionRef.value) {
            foreignObserver.value.unobserve(foreignSectionRef.value)
        }
    }
}
// 系统平台板块进入视口时的回调函数
const handlePaltformIntersection = (entries) => {
    const entry = entries[0]
    if (entry.isIntersecting) {
        paltformVisible.value = true

        // 加载后取消观察
        if (paltformObserver.value && paltformSectionRef.value) {
            paltformObserver.value.unobserve(paltformSectionRef.value)
        }
    }
}
// 关于我们板块进入视口时的回调函数
const handleSectionIntersection = (entries) => {
    const entry = entries[0]
    if (entry.isIntersecting) {
        sectionVisible.value = true

        // 加载后取消观察
        if (sectionObserver.value && sectionSectionRef.value) {
            sectionObserver.value.unobserve(sectionSectionRef.value)
        }
    }
}
//服务流程板块进入视口时的回调函数
const handleserverIntersection = (entries) => {
    const entry = entries[0]
    if (entry.isIntersecting) {
        serverVisible.value = true

        // 加载后取消观察
        if (serverObserver.value && serverSectionRef.value) {
            serverObserver.value.unobserve(serverSectionRef.value)
        }
    }
}
//专业服务板块进入视口时的回调函数
const handleServerSectionIntersection = (entries) => {
    const entry = entries[0]
    if (entry.isIntersecting) {
        serverSectionVisible.value = true

        // 加载后取消观察
        if (serverSectionObserver.value && serverSection.value) {
            serverSectionObserver.value.unobserve(serverSection.value)
        }
    }
}
// 全代码双抬头省心代理板块进入视口时的回调函数
const handleAgentIntersection = (entries) => {
    const entry = entries[0]
    if (entry.isIntersecting) {
        agentVisible.value = true

        // 加载后取消观察
        if (agentObserver.value && agentSectionRef.value) {
            agentObserver.value.unobserve(agentSectionRef.value)
        }
    }
}

// 出海企业专项资源服务板块进入视口时的回调函数
const handleForeignPointIntersection = (entries) => {
    const entry = entries[0]
    if (entry.isIntersecting) {
        foreignPointVisible.value = true

        // 加载后取消观察
        if (foreignPointObserver.value && foreignPointSectionRef.value) {
            foreignPointObserver.value.unobserve(foreignPointSectionRef.value)
        }
    }
}
const Items = ref([
    {
        id: 1,
        title: 'SAILOR<br/>佛山市势联出海合规进出口服务有限公司',
        text: '跨境全链路合规服务商',
        des: 'Cross-border Full-chain Compliance Service Provider',
        image: 'https://www.sailortrade.top/imgs/play1.webp',
    },
    {
        id: 2,
        title: '跨境资源整合',
        text: '连接全球优质资源',
        des: '整合海外渠道、人才、供应链等关键资源',
        image: 'https://www.sailortrade.top/imgs/play2.webp',
    },
    {
        id: 3,
        title: '全球市场拓展',
        text: '专业的海外市场解决方案',
        des: '帮助企业快速进入目标市场，降低国际化风险',
        image: 'https://www.sailortrade.top/imgs/play3.webp',
    },
]);
const imageList1 = ref([
    {
        image: 'https://www.sailortrade.top/imgs/zizhi.webp',
        zh: '跨境资质',
        en: 'Qualifications',
        description: '进出口权/电商备案/电子口岸入网/地方综试区备案与对接/出口退免税备案'
    },
    {
        image: 'https://www.sailortrade.top/imgs/guanwu.webp',
        zh: '关务赋能',
        en: 'Customs Compliance',
        description: '商品归类/单证制作/0110-9610-9710-9810出口申报/货代对接/商品检验'
    },
    {
        image: 'https://www.sailortrade.top/imgs/caiwu.webp',
        zh: '财务支持',
        en: 'Financial Support',
        description: '合规框架规划/资金收汇链路/外汇产品/代理电商记账/政策解读与风险规避'
    },
]);
const imageList2 = ref([
    {
        image: 'https://www.sailortrade.top/imgs/shuiwu.webp',
        zh: '税务规划',
        en: 'Tax Planning',
        description: '出口退免税申报/退免税单证收集审核/税局实地考察辅导/无票免税/核定征收'
    },
    {
        image: 'https://www.sailortrade.top/imgs/fawu.webp',
        zh: '法务保障',
        en: 'Legal Support',
        description: '基础跨境法律顾问/知识产权专利排查/全球产品资质/涉外案件纠纷处理'
    },
    {
        image: 'https://www.sailortrade.top/imgs/jishu.webp',
        zh: '技术系统',
        en: 'Technology-driven',
        description: '单证综合管理服务系统/跨境电子申报系统/高效制单/单证电子储存/直连海关'
    }
]);
const caseList = ref([
    {
        image: 'https://www.sailortrade.top/imgs/case1.webp',
        title: '入选福布斯中国年度好品牌TOP50',
        des: '⾃营品牌独⽴站文本​',
        text: '年均GMV达1000W+',
    },
    {
        image: 'https://www.sailortrade.top/imgs/case2.webp',
        title: '⼴东浙商摩配协会常务副会⻓单位',
        des: '主营Amazon​',
        text: '汽摩配产品出海',
    },
    {
        image: 'https://www.sailortrade.top/imgs/case3.webp',
        title: '美国中⾼端⻋⾝膜品牌',
        des: '美国知名改⾊膜品牌',
        text: '多种类商品归类裁定',
    },
    {
        image: 'https://www.sailortrade.top/imgs/case4.webp',
        title: '独立站品牌出口',
        des: '⾃建独⽴站',
        text: '⽆票免征',
    },
    {
        image: 'https://www.sailortrade.top/imgs/case5.webp',
        title: '中国⼾外灯饰智造出海',
        des: '主营TIKTOK和AMAZOM',
        text: '9610⼩包出⼝',
    },
    {
        image: 'https://www.sailortrade.top/imgs/case6.webp',
        title: '英国Bimax 药业公司旗下中国⼦公司',
        des: '主营⾹港市场，⼀般贸易模式',
        text: '由佛山市势联出海合规进出口服务有限公司协助⾃主报关',
    },
]);
const sourceList = ref([
    {
        image: 'https://www.sailortrade.top/imgs/source11.webp',
        description: '佛⼭市税务局​',
    },
    {
        image: 'https://www.sailortrade.top/imgs/source6.webp',
        description: '深圳前海综保区​',
    },
    {
        image: 'https://www.sailortrade.top/imgs/source12.webp',
        description: '深圳前海税务局',
    },
    {
        image: 'https://www.sailortrade.top/imgs/source1.webp',
        description: '汕头跨境电商园区',
    },
    {
        image: 'https://www.sailortrade.top/imgs/source2.webp',
        description: '中山报税物流中心',
    },
    {
        image: 'https://www.sailortrade.top/imgs/source3.webp',
        description: '⻰南跨境电商监管中⼼',
    },
    {
        image: 'https://www.sailortrade.top/imgs/source4.webp',
        description: '东莞跨境电商中⼼园区',
    },
    {
        image: 'https://www.sailortrade.top/imgs/source5.webp',
        description: '招商银⾏​',
    },
    {
        image: 'https://www.sailortrade.top/imgs/source7.webp',
        description: '⼴州海关​',
    },
    {
        image: 'https://www.sailortrade.top/imgs/source8.webp',
        description: '⼴州⽩云机场海关​',
    },
    {
        image: 'https://www.sailortrade.top/imgs/source9.webp',
        description: '⼴州⽩云税务局​',
    },
    {
        image: 'https://www.sailortrade.top/imgs/source10.webp',
        description: '中⼭⺠众税务局​',
    },
    {
        image: 'https://www.sailortrade.top/imgs/source11.webp',
        description: '佛⼭市税务局​',
    },
    {
        image: 'https://www.sailortrade.top/imgs/source6.webp',
        description: '深圳前海综保区​',
    },
    {
        image: 'https://www.sailortrade.top/imgs/source12.webp',
        description: '深圳前海税务局',
    },
]);
const experienceList = ref([
    {
        image: 'https://www.sailortrade.top/imgs/ex10.webp',
        text: "跨境电商综试区的国务院申报⼯作",
    },
    {
        image: 'https://www.sailortrade.top/imgs/ex11.webp',
        text: "全国⾸票跨境电商跨关区出⼝退运",
    },
    {
        image: 'https://www.sailortrade.top/imgs/ex12.webp',
        text: "虎⻔港综保区空港中⼼规划与设计",
    },
    {
        image: 'https://www.sailortrade.top/imgs/ex1.webp',
        text: "联合商业银⾏跨境阳光化数字解决⽅案",
    },
    {
        image: 'https://www.sailortrade.top/imgs/ex2.webp',
        text: "中⼭保税物流中⼼战略合作单位",
    },
    {
        image: 'https://www.sailortrade.top/imgs/ex3.webp',
        text: "江西⾸单跨境电商内陆转关家具出⼝",
    },
    {
        image: 'https://www.sailortrade.top/imgs/ex4.webp',
        text: "东莞市跨境电商中⼼园区规划与设计",
    },
    {
        image: 'https://www.sailortrade.top/imgs/ex5.webp',
        text: "⾸单⽆票免征跨境电商免税政策落地",
    },
    {
        image: 'https://www.sailortrade.top/imgs/ex6.webp',
        text: "⼴州⾸票跨境电商零售出⼝退税",
    },
    {
        image: 'https://www.sailortrade.top/imgs/ex7.webp',
        text: "⼴州荔湾出海服务中⼼常驻窗⼝",
    },
    {
        image: 'https://www.sailortrade.top/imgs/ex8.webp',
        text: "珠西地区⾸家跨境保税新零售旗舰店",
    },
    {
        image: 'https://www.sailortrade.top/imgs/ex9.webp',
        text: "⼴州空港综合保税区（南区）规划设计",
    },
    {
        image: 'https://www.sailortrade.top/imgs/ex10.webp',
        text: "跨境电商综试区的国务院申报⼯作",
    },
    {
        image: 'https://www.sailortrade.top/imgs/ex11.webp',
        text: "全国⾸票跨境电商跨关区出⼝退运",
    },
    {
        image: 'https://www.sailortrade.top/imgs/ex12.webp',
        text: "虎⻔港综保区空港中⼼规划与设计",
    },

]);
const extendedExperienceList = ref([]);
extendedExperienceList.value = [
    ...experienceList.value,
    ...experienceList.value,
    ...experienceList.value
];
const extendedSourceList = ref([]);
extendedSourceList.value = [
    ...sourceList.value,
    ...sourceList.value,
    ...sourceList.value
];
// 活动卡片轮播相关状态
const activeCardIndex = ref(0);
const isTransitioning = ref(false);
const cardInterval = ref(null);

const activityCards = ref([
    {
        id: 1,
        image: 'https://www.sailortrade.top/imgs/activity1.webp',
        title: '税企座谈会',
        description: '我司商务代表应邀参加佛山市税务局、市工商联联合主办的"合规运营，共促发展"税企面对面座谈会，助理深化税企协作'
    },
    {
        id: 2,
        image: 'https://www.sailortrade.top/imgs/activity2.webp',
        title: '俄罗斯市场招商会',
        description: '我司代表于11月26日出席“一站式破局俄罗斯市场”招商会，并发表演讲，助力华南跨境电商卖家拓展俄罗斯新兴市场。'
    },
    {
        id: 3,
        image: 'https://www.sailortrade.top/imgs/activity3.webp',
        title: '跨境电商合规私享会',
        description: '9月25日，我司财税顾问受邀主讲顺德跨境电商协会&顺势出海《2025跨境电商合规私享会》，助力企业政策把控，合规风控。'
    }
]);
// 当前激活的索引
const activeIndex = ref(0);

// 鼠标进入处理函数
const handleMouseEnter = (index) => {
    activeIndex.value = index;
};

// 内容数据
const contentList = ref([
    {
        title: "全球主体注册",
        img: "https://www.sailortrade.top/imgs/server1.webp",
        details: [
            "国内挂靠地址",
            "国内-香港-本土公司注册",
            "香港秘书地址-亚马逊二审地址实租",
        ]
    },
    {
        title: "会计与资金账户",
        img: "https://www.sailortrade.top/imgs/server2.webp",
        details: [
            "审计报告",
            "ODI备案",
            "税务异常",
            "境内外公司代理记账报税",
            "境内外银行对公账户有"
        ]
    },
    {
        title: "政策补贴申领",
        img: "https://www.sailortrade.top/imgs/server3.webp",
        details: [
            "人才补贴",
            "跨境电商补贴",
            "科技公司补贴",
            "横琴-海南自贸区税收优惠",
            "其他补贴"
        ]
    },
    {
        title: "特殊跨境需求",
        img: "https://www.sailortrade.top/imgs/server4.webp",
        details: [


            "小币种收汇",
            "供应链融资",
            "跨境人才招聘",
            "海外投资移民",
            "核定征收园区个体户",
        ]
    }
]);
const startCardRotation = () => {
    cardInterval.value = setInterval(() => {
        isTransitioning.value = true;
        setTimeout(() => {
            activeCardIndex.value = (activeCardIndex.value + 1) % activityCards.value.length;
            isTransitioning.value = false;
        }, 1000); // 与CSS过渡时间匹配
    }, 5000); // 每5秒切换一次
};

onMounted(() => {
    // 初始化活动卡片数据
    activityCards.value[0].image = 'https://www.sailortrade.top/imgs/activity1.webp';
    activityCards.value[1].image = 'https://www.sailortrade.top/imgs/activity2.webp';
    activityCards.value[2].image = 'https://www.sailortrade.top/imgs/activity3.webp';

    // 创建 Intersection Observer 实例
    observer.value = new IntersectionObserver(handleIntersection, {
        root: null, // 使用视口作为根
        rootMargin: '0px', // 不使用边距
        threshold: 0.1 // 当10%的元素可见时触发
    });
    // 创建 Intersection Observer 实例 - 宏观板块
    featuresObserver.value = new IntersectionObserver(handleFeaturesIntersection, {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    });

    // 创建 Intersection Observer 实例 - 外贸凭证板块
    foreignObserver.value = new IntersectionObserver(handleForeignIntersection, {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    });
    // 创建 Intersection Observer 实例 - 系统平台板块
    paltformObserver.value = new IntersectionObserver(handlePaltformIntersection, {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    });
    // 创建 Intersection Observer 实例 - 监管资源板块
    sectionObserver.value = new IntersectionObserver(handleSectionIntersection, {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    });
    // 创建 Intersection Observer 实例 - 服务流程板块
    serverObserver.value = new IntersectionObserver(handleserverIntersection, {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    });
    // 创建 Intersection Observer 实例 - 专业服务板块
    serverSectionObserver.value = new IntersectionObserver(handleServerSectionIntersection, {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    });
    // 创建 Intersection Observer 实例 - 专业服务板块
    agentObserver.value = new IntersectionObserver(handleAgentIntersection, {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    });
    // 创建 Intersection Observer 实例 - 出海企业专项资源服务板块
    foreignPointObserver.value = new IntersectionObserver(handleForeignPointIntersection, {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    });
    // 开始观察各元素
    if (dataSectionRef.value) {
        observer.value.observe(dataSectionRef.value);
    }

    if (featureSectionRef.value) {
        featuresObserver.value.observe(featureSectionRef.value);
    }

    if (foreignSectionRef.value) {
        foreignObserver.value.observe(foreignSectionRef.value);
    }
    if (paltformSectionRef.value) {
        paltformObserver.value.observe(paltformSectionRef.value);
    }
    if (sectionSectionRef.value) {
        sectionObserver.value.observe(sectionSectionRef.value);
    }
    if (serverSectionRef.value) {
        serverObserver.value.observe(serverSectionRef.value);
    }
    if (serverSection.value) {
        serverSectionObserver.value.observe(serverSection.value);
    }
    if (agentSectionRef.value) {
        agentObserver.value.observe(agentSectionRef.value);
    }
    if (foreignPointSectionRef.value) {
        foreignPointObserver.value.observe(foreignPointSectionRef.value);
    }
    // 开始轮播
    startCardRotation();
});

onBeforeUnmount(() => {
    // 清理 Intersection Observer
    if (observer.value && dataSectionRef.value) {
        observer.value.unobserve(dataSectionRef.value);
    }

    if (featuresObserver.value && featureSectionRef.value) {
        featuresObserver.value.unobserve(featureSectionRef.value);
    }


    if (cardInterval.value) {
        clearInterval(cardInterval.value);
    }

    if (foreignObserver.value && foreignSectionRef.value) {
        foreignObserver.value.unobserve(foreignSectionRef.value);
    }

    if (paltformObserver.value && paltformSectionRef.value) {
        paltformObserver.value.unobserve(paltformSectionRef.value);
    }

    if (sectionObserver.value && sectionSectionRef.value) {
        sectionObserver.value.unobserve(sectionSectionRef.value);
    }

    if (serverSectionObserver.value && serverSection.value) {
        serverSectionObserver.value.unobserve(serverSection.value);
    }
    if (agentObserver.value && agentSectionRef.value) {
        agentObserver.value.unobserve(agentSectionRef.value);
    }
    if (foreignPointObserver.value && foreignPointSectionRef.value) {
        foreignPointObserver.value.unobserve(foreignPointSectionRef.value);
    }
});
</script>
<style scoped>
.home-page {
    background-image: url('https://www.sailortrade.top/imgs/background.webp');
}

.divier-column {
    margin: 20px auto;
    border: 1px solid #bccae5;
    width: 200px;
}

.divier-row {
    margin: auto 20px;
    border: 1px solid #bccae5;
    height: 100px;
}

img {
    image-rendering: -webkit-optimize-contrast;
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    border: none;
    height: 80px;
    padding: 0 40px;
    box-sizing: border-box;
    position: absolute;
    z-index: 999;
    transition: all 0.5s ease;
}

.header:hover {
    background-color: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.header-left {
    display: flex;
    align-items: center;
}


.logo {
    width: 356px;
    height: 90px;
}

.company-name {
    font-size: 24px;
    font-weight: bold;
    color: #333;
}

.header-middle {
    display: flex;
    align-items: center;
}

.header-right {
    display: flex;
    flex-direction: row;
    gap: 40px;
}

.header-download {
    display: flex;
    flex-direction: row;
    background-color: #2a82e4;
    align-items: center;
    border-radius: 10px;
}

.header-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 5px 5px 5px 0px;
}

.icon {
    margin: 5px;
    width: 30px;
    height: 30px;
}

.nav-menu {
    display: flex;
    list-style: none;
}

.nav-item {
    margin-left: 30px;
}

.nav-link {
    text-decoration: none;
    color: #333;
    font-size: 16px;
    transition: color 0.3s ease;
}

.nav-link:hover {
    color: #00a0bc;
    /* 悬停时颜色改为 #00a0bc */
    transform: translateY(-2px);
    /* 稍微上移效果 */
}

.main-content {
    padding: 0px 0;
}

/* 轮播图板块样式 */
.carousel-section {
    width: 100%;
    height: 800px;
    margin-bottom: 40px;
}

.carousel-image {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    color: white;
}

.carousel-title {
    font-size: 60px;
    text-wrap: wrap;
    margin: 15% 0% 0px 23%
}

.carousel-text {
    font-size: 24px;
    margin: 2% 0% 0px 25%
}

.carousel-des {
    font-size: 26px;
    margin: 2% 0% 0px 23%
}

:deep(.carousel-section .el-carousel__container) {
    height: 800px !important;
}

/* 在现有CSS基础上添加以下媒体查询 */

/* 移动端适配 - 轮播图板块 */
@media (max-width: 768px) {
    .case-main {
        margin-bottom: 50px !important;
    }
    :deep(.carousel-section.el-carousel__arrow){
        display: none;
    }
    :deep(.carousel-section .el-carousel__container) {
        margin-top: 60px;
        height: 55vh !important;
        /* 使用视口高度，更适合移动端 */
    }

    .carousel-image {
        background-size: cover;
        background-position: center;
    }

    .carousel-title {
        font-size: 28px;
        margin: 20% 5% 0 5%;
        text-align: center;
        text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.7);
        /* 添加阴影提高可读性 */
    }

    .carousel-text {
        font-size: 16px;
        margin: 3% 5% 0 5%;
        text-align: center;
        text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.7);
    }

    .carousel-des {
        font-size: 14px;
        margin: 3% 5% 0 5%;
        text-align: center;
        text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.7);
    }

    .carousel-section{
        height: 400px !important;
    }
    
}

/* 针对更小屏幕的优化 */
@media (max-width: 480px) {
    :deep(.carousel-section .el-carousel__container) {
       height: 50vh !important;
        /* 使用视口高度，更适合移动端 */
    }

    .carousel-title {
        font-size: 22px;
        margin: 30% 5% 0 5%;
    }

    .carousel-text {
        font-size: 14px;
        margin: 2% 5% 0 5%;
    }

    .carousel-des {
        font-size: 12px;
        margin: 2% 5% 0 5%;
    }

    .case-main {
        margin-bottom: 0px !important;
    }

    .carousel-section{
        height: 300px !important;
    }
}

/* 确保在各种移动设备上都有良好表现 */
@media (min-width: 320px) and (max-width: 480px) {
    :deep(.carousel-section .el-carousel__container) {
      height: 300px !important;
        /* 使用视口高度，更适合移动端 */
    }
    .carousel-section{
        height: 300px !important;
    }
    .carousel-title {
        font-size: 20px;
        line-height: 1.3;
    }

    .carousel-text {
        font-size: 13px;
        line-height: 1.3;
    }

    .carousel-des {
        font-size: 11px;
        line-height: 1.3;
    }
}

/* 标题板块样式 */
.title-main {
    margin: 50px auto 0px auto;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    max-width: 1200px;
}

.title-section {
    text-align: center;
    padding: 0 90px;
    margin-bottom: 40px;
    opacity: 0;
    transform: translateX(-100px);
    transition: all 0.8s ease-out;
}

.section-img {
    width: 300px;
    height: 400px;
    opacity: 0;
    transform: translateX(100px);
    transition: all 0.8s ease-out;
}

.title-section.slide-in-left,
.section-img.slide-in-right {
    opacity: 1;
    transform: translateY(0) translateX(0);
}

.section-title {
    font-size: 40px;
    color: #333;
    margin-bottom: 20px;
    font-weight: bold;
}

.section-description {
    font-size: 24px;
    color: #666;
    line-height: 1.6;
    text-align: start;
}

/* 关于我们板块移动端适配 */
@media (max-width: 768px) {
    .title-main {
        flex-direction: column;
        margin: 30px auto;
        padding: 0 20px;
        gap: 30px;
    }

    .title-section {
        padding: 0 10px;
        margin-bottom: 20px;
    }

    .section-description {
        font-size: 18px;
        line-height: 1.5;
        text-align: center;
        padding: 0 10px;
    }

    /* 移除首行的缩进，使用更简单的段落格式 */
    .section-description {
        text-align: left;
        margin: 10px 0;
    }

    .section-description:first-child {
        margin-top: 0;
    }

    .section-img {
        width: 250px;
        height: 300px;
        max-width: 90vw;
        /* 确保图片不会超出屏幕 */
    }

    .section-title {
        font-size: 28px;
    }
}

@media (max-width: 480px) {
    .title-main {
        padding: 60px 15px 30px 15px;
        gap: 20px;
    }

    .title-section {
        padding: 0 5px;
        margin-bottom: 15px;
    }

    .section-description {
        font-size: 16px;
        line-height: 1.4;
        padding: 0 5px;
    }

    .section-img {
        width: 200px;
        height: 250px;
        max-width: 85vw;
    }

    .section-title {
        font-size: 24px;
    }
}

/* 针对极小屏幕的优化 */
@media (max-width: 360px) {
    .title-main {
        padding: 60px 15px 20px 15px;
    }

    .section-description {
        font-size: 13px;
    }

    .section-img {
        width: 180px;
        height: 220px;
    }
}

/* 功能模块板块样式 */
.features-section {
    padding: 0 150px;
    margin-top: 100px;
}

.features-container {
    display: flex;
    justify-content: center;
    gap: 20px;
}

.feature-item {
    flex: 1;
    text-align: center;
    padding: 20px;
    opacity: 0;
    transform: translateY(50px) translateX(-50px);
    transition: all 0.8s ease-out;
}

.feature-item:nth-child(3n+1) {
    transform: translateY(150px)
        /* 从左下角进入 */
}

.feature-item:nth-child(3n+2) {
    transform: translateY(150px);
    /* 从下方进入 */
}

.feature-item:nth-child(3n+3) {
    transform: translateY(150px)
        /* 从右下角进入 */
}

.feature-item.slide-in-left,
.feature-item.slide-in-right {
    opacity: 1;
    transform: translateY(0) translateX(0);
}




.feature-title {
    font-size: 40px;
    color: #333;
    margin: 0;
    transition: all 0.3s ease;
}

.feature-content {
    color: #615f5f;
    font-size: 30px;
}

/* 三大宗旨板块移动端适配 */
@media (max-width: 768px) {
    .features-section {
        padding: 0 20px;
        margin-top: 40px;
    }

    .features-container {
        flex-direction: column;
        align-items: center;
        gap: 15px;
    }

    .feature-item {
        width: 100%;
        max-width: 400px;
        padding: 15px;
    }

    .feature-title {
        font-size: 32px;
    }

    .feature-content {
        font-size: 24px;
    }

    .divier-row {
        display: none;
        /* 在移动端隐藏分割线 */
    }
}

@media (max-width: 480px) {
    .features-section {
        padding: 0 15px;
        margin-top: 30px;
    }

    .feature-item {
        padding: 10px;
    }

    .feature-title {
        font-size: 28px;
    }

    .feature-content {
        font-size: 20px;
    }
}

/* 数据列表板块样式 */
.data-section {
    margin-top: 80px ;
    width: 100%;
    background-size: cover;
}

.data-title {
    font-size: 40px;
    text-align: center;
}

.data-main {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    /* 允许换行 */
    gap: 20px;
    /* 添加间距 */
}

.data-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 200px;
    /* 设置最小宽度 */
    flex: 1;
    /* 允许弹性伸缩 */
    margin: 0 10px;
    /* 添加边距 */
}

.data-count {
    display: flex;
    line-height: 84px;
    align-items: baseline;
}

:deep(.el-statistic__content) {
    display: flex;
    color: #3773f5;
    font-size: 60px;
    line-height: 84px;
    font-weight: 700;
    align-items: baseline;
}

.data-unit {
    font-weight: 400;
    color: #1a1a1a;
    font-size: 26px;
    margin-left: 4px;
}

.data-des {
    color: #484848;
    font-size: 20px;
    margin: 0;
    padding: 0;
}

/* 数据列表板块移动端适配 */
@media (max-width: 768px) {
    .data-section {
        margin-top: 40px;
        height: auto;
        min-height: 300px;
    }

    .data-title {
        font-size: 28px;
        margin-bottom: 20px;
    }

    .data-main {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        text-align: center;
        padding: 20px;
    }

    .data-card {
        min-width: 140px;
        flex: 1;
        margin: 0;
        padding: 10px;
        max-width: 180px;
        /* 限制最大宽度，确保每行能放下两个 */
    }

    :deep(.el-statistic__content) {
        font-size: 40px;
        line-height: 60px;
    }

    .data-unit {
        font-size: 20px;
    }

    .data-des {
        font-size: 16px;
        text-align: center;
    }
}

@media (max-width: 480px) {
    .data-section {
        margin-top: 40px ;
        min-height: 250px;
    }

    .data-title {
        font-size: 24px;
        margin-bottom: 15px;
    }

    .data-main {
        gap: 15px;
        margin: 0 15px;
    }

    .data-card {
        min-width: 120px;
        max-width: 160px;
        padding: 8px;
    }

    :deep(.el-statistic__content) {
        font-size: 32px;
        line-height: 50px;
    }

    .data-unit {
        font-size: 18px;
    }

    .data-des {
        font-size: 14px;
    }
}

/* 服务内容板块 */
.scrolling-images-section {
    margin-top: 100px;
}

.source-section {
    margin-top: 90px;
}

@media (max-width: 768px) {
    .scrolling-images-section {
        margin-top: 40px;
    }
    .source-section {
        margin-top: 30px;
    }
}

.scrolling-title {
    font-size: 40px;
    text-align: center;
}

.proservice-column {
    display: flex;
    flex-direction: row;
    margin: 30px auto;
    justify-content: center;
}

.scrolling-en {
    font-size: 20px;
    text-align: center;
}

.scrolling-container-css {
    width: 100%;
    overflow: hidden;
    position: relative;
    height: 100%;
}

.scrolling-track {
    display: flex;
    max-width: 3500px;
    justify-content: center;
    width: fit-content;
    animation: scroll-left 30s linear infinite;
}

.scrolling-track:hover {
    animation-play-state: paused;
}

@keyframes scroll-left {
    0% {
        transform: translateX(0);
    }

    100% {
        transform: translateX(-50%);
    }
}

.scrolling-item {
    flex: 0 0 auto;
    width: 330px;
    height: 100%;
    display: flex;
    margin: 0px 25px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    position: relative;
    border-radius: 20px;
    border: 2px solid #fff;
    overflow: hidden;
    background-color: #fff;
}

.proservice-item {
    flex: 0 0 auto;
    width: 330px;
    height: 100%;
    display: flex;
    margin: 0px 40px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    position: relative;
    border-radius: 20px;
    border: 2px solid #fff;
    overflow: hidden;
    background-color: #fff;
    opacity: 0;
    transform: translateY(50px);
    transition: all 0.8s ease-out;
}

.image-title {
    display: flex;
    flex-direction: row;
    width: 100vw;
    gap: 50px;
    align-items: center;
    color: #ffffff;
    height: 44px;
    background: rgba(0, 0, 0, 0.7);
    padding: 0 30px;
    transition: all 0.3s ease;
    text-align: center;
}

.image-description {
    margin: 0px 5px;
}

.proservice-item.slide-up {
    opacity: 1;
    transform: translateY(0);
}

.proservice-column:first-child .proservice-item:nth-child(1) {
    transition-delay: 0.1s;
}

.proservice-column:first-child .proservice-item:nth-child(2) {
    transition-delay: 0.2s;
}

.proservice-column:first-child .proservice-item:nth-child(3) {
    transition-delay: 0.3s;
}

.proservice-column:last-child .proservice-item:nth-child(1) {
    transition-delay: 0.4s;
}

.proservice-column:last-child .proservice-item:nth-child(2) {
    transition-delay: 0.5s;
}

.proservice-column:last-child .proservice-item:nth-child(3) {
    transition-delay: 0.6s;
}


.scrolling-image {
    width: 100%;
    height: 200px;
    object-fit: cover;
    object-position: center;
}

.image-des {
    text-wrap: nowrap;
    text-align: center;
    font-size: 16px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin-top: 0px;
    color: #ffffff;
    height: 35px;
    background: rgba(0, 0, 0, 0.7);
    transition: all 0.3s ease;
}

.scrolling-item-card {
    padding: 20px;
    height: 90px;
}

.scrolling-logo {
    margin-top: 20px;
    width: auto;
    height: 80px;
}

@media (max-width: 768px) {
    .proservice-column {
        flex-direction: column;
        align-items: center;
        gap: 20px;
    }

    .proservice-item {
        width: 90vw;
    }

    .scrolling-image {
        height: 150px;
    }

    .image-title {
        width: 90vw;
        padding: 0;
        justify-content: space-around;
    }

    .scrolling-title {
        font-size: 28px;
    }

    .scrolling-en {
        font-size: 16px;
    }
}

/* 优势模块样式 */
.advantage-content{
    margin-top: 60px;
}
.advantage-title {
    font-size: 40px;
    text-align: center;
}

.advantage-en {
    font-size: 20px;
    text-align: center;
}

.advantage-main {
    display: flex;
    width: 920px;
    flex-direction: column;
    margin: 50px auto;
    gap: 20px;
    align-items: flex-start;
}

.advantage-column {
    display: flex;
    flex-direction: row;
    gap: 40px;
    align-items: center;
    text-wrap: nowrap;
}

.advantage-img {
    width: 75px;
    height: 75px;
    color: #0651a4;
}

.advantage-info {
    display: flex;
    flex-direction: row;
    gap: 40px;
}

.advantage-text {
    font-size: 20px;
    color: #0651a4;
}

.advantage-des {
    font-size: 18px;
}

/* 优势板块移动端适配 */
@media (max-width: 768px) {
    .advantage-content {
        margin-top: 40px;
    }

    .advantage-title {
        font-size: 32px;
    }

    .advantage-en {
        font-size: 18px;
    }

    .advantage-main {
        flex-direction: column;
        margin: 30px auto;
        width: 100%;
        max-width: 500px;
        align-items: center;
    }

    .advantage-info {
        flex-direction: column;
        gap: 0px;
        align-items: center;
    }

    .advantage-column {
        flex-direction: row;
        align-items: flex-start;
        text-wrap: wrap;
        margin-bottom: 30px;
        gap: 20px;
    }

    .advantage-img {
        display: none;
    }

    .advantage-text {
        font-size: 20px;
        margin-bottom: 10px;
    }

    .advantage-des {
        font-size: 18px;
        text-align: start;
        max-width: 330px;
    }

    .divier-column {
        width: 150px;
    }
}

@media (max-width: 480px) {
    .advantage-title {
        font-size: 28px;
    }

    .advantage-en {
        font-size: 16px;
    }

    .advantage-main {
        margin: 20px auto;
    }

    .advantage-column {
        margin-bottom: 25px;
    }

    .advantage-img {
        display: none;
    }

    .advantage-text {
        font-size: 20px;
    }

    .advantage-des {
        font-size: 18px;
        text-align: start;
    }
}

/* 系统平台介绍板块样式 */
.paltform-content {
    margin-top: 90px ;
    opacity: 0;
    transform: translateY(50px);
    transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.paltform-content.visible {
    opacity: 1;
    transform: translateY(0);
}

.paltform-title {
    font-size: 40px;
    text-align: center;
}

.paltform-en {
    font-size: 20px;
    text-align: center;
}


.paltform-card {
    display: flex;
    flex-direction: row;
    margin: 50px auto;
    background-color: #f8f9fa;
    border: 2px solid #fff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
    border-radius: 20px;
    overflow: hidden;
    justify-content: center;
    max-width: 1150px;
}
.paltform-card1 {
    display: flex;
    flex-direction: row;
    margin: 50px auto;
    background-color: #f8f9fa;
    border: 2px solid #fff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
    border-radius: 20px;
    overflow: hidden;
    justify-content: center;
    max-width: 1150px;
}
.paltform-img-height {
    width: auto;
    height: 300px;
    object-fit: cover;
}

.paltform-img {
    height: 300px;
    width: 700px;
    object-fit: cover;
}

.paltform-text-left {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
}

.paltform-text-right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
}

.paltform-des {
    padding: 20px 50px;
    font-size: 20px;
    text-wrap: nowrap;
}

@media (max-width: 768px) {
    .paltform-content {
        margin: 40px 0px 0px 0px;
    }
    .paltform-card{
        flex-direction: column;
        margin: 20px 15px;
    }
    .paltform-card1{
        flex-direction: column-reverse;
        margin: 20px 15px;
    }
    .paltform-title{
        font-size: 28px;
        padding: 0 10px;
    }
    .paltform-en{
        font-size: 18px;
        padding: 0 10px;
    }
    .paltform-img{
        width: 100%;
        height: auto;
        max-height: 270px;
        object-fit: cover;
    }
    .paltform-img-height{
        width: 100%;
        height: auto;
        max-height: 200px;
        object-fit: cover;
    }
    .paltform-text-left,
    .paltform-text-right{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 10px;
    }
    .paltform-des{
        padding: 10px 15px;
        font-size: 16px;
        text-wrap: wrap;
        text-align: center;
    }
}

@media (max-width: 480px) {
    .paltform-title{
        font-size: 24px;
    }
    .paltform-en{
        font-size: 16px;
    }
    .paltform-des{
        padding: 8px 10px;
        font-size: 14px;
    }
    .paltform-card{
        margin: 20px 10px;
    }
    .paltform-card1{
        margin: 20px 10px;
    }
}

/* 项目经验样式 */
.experience-content {
    margin-top: 90px;
}

@media (max-width: 768px) {
    .experience-content {
        margin-top: 0px;
    }
}

.experience-title {
    font-size: 40px;
    text-align: center;
}

.experience-en {
    font-size: 20px;
    text-align: center;
    margin-bottom: 40px;
}

.experience-text {
    text-wrap: nowrap;
    text-align: center;
    font-size: 16px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin-top: 0px;
    color: #ffffff;
    height: 35px;
    background: rgba(0, 0, 0, 0.7);
    transition: all 0.3s ease;
}

@media (max-width: 768px) {
    .experience-title {
        font-size: 28px;
    }

    .experience-en {
        font-size: 16px;
    }
}

/* 优秀案例板块样式 */
.case-content {
    margin-top: 90px;
    min-height: 600px;
}

.case-title {
    font-size: 40px;
    text-align: center;
}

.case-main {
    margin-top: 40px;
    position: relative;
}

.case-en {
    font-size: 20px;
    text-align: center;
}

:deep(.case-carousel .el-carousel__container) {
    position: relative;
    width: 1100px;
    height: 350px;
    display: flex;
    margin-bottom: 40px;
}

:deep(.case-carousel .el-carousel__item) {
    background-color: #fdfeff;
    border: 2px solid #fff;
    border-radius: 20px;
    width: 1100px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

:deep(.case-carousel .el-carousel__item--card.is-active) {
    transform: translateX(218.25px) !important;
}

:deep(.case-carousel .el-carousel__indicator--horizontal is-active) {
    color: #000 !important;
}

:deep(.case-carousel .el-carousel__item--card) {
    display: flex;
    flex-direction: row;

}

.case-img {
    width: 700px;
    height: 350px;
}

.case-item-title {
    margin: 50px 0px 0px 50px;
    font-size: 30px;
    line-height: 44px;
    font-weight: 500;
}

.case-text {
    display: flex;
    flex-direction: column;
    font-size: 18px;
    line-height: 24px;
    font-weight: 400;
    padding: 40px 0px;
    gap: 50px;
}

/* 优秀案例板块移动端适配 */
@media (max-width: 820px) {
    :deep(.case-carousel .el-carousel__item--card.is-active) {
        transform: translateX(0px) !important;
    }
}

@media (max-width: 768px) {
    :deep(.el-carousel--horizontal)
    {
        height: 400px !important;
    }
    .case-content {
        margin-top: 30px;
        min-height: auto;
    }

    .case-title {
        font-size: 28px;
    }

    .case-en {
        font-size: 16px;
    }

    :deep(.case-carousel .el-carousel__container) {
        width: 80vw !important;
        height: auto !important;
        max-width: 400px;
        max-height: none;
    }

    :deep(.case-carousel .el-carousel__item) {
        width: 80vw !important;
        height: auto !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
    }

    :deep(.case-carousel .el-carousel__item--card.is-active) {
        transform: translateX(0) !important;
    }

    :deep(.case-carousel .el-carousel__item--card) {
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
    }

    .case-img {
        width: 90vw !important;
        height: 60vw !important;
        max-height: 240px;
        object-fit: cover;
        order: 1;
        /* 图片排在第一位 */
    }

    .case-item-title {
        margin: 15px 10px 10px 10px;
        font-size: 20px;
        line-height: 26px;
        text-align: center;
        order: 2;
    }

    .case-text {
        display: block;
        padding: 10px;
        gap: 10px;
        order: 3;
    }

    .case-text div {
        font-size: 14px;
        line-height: 18px;
        text-align: center;
    }

    :deep(.case-carousel .el-carousel__item--card.is-active) {
        transform: translateX(50px) !important;
    }
}

@media (max-width: 480px) {
        :deep(.el-carousel--horizontal)
    {
        height: 360px !important;
    }
    :deep(.case-carousel .el-carousel__container) {
        height: auto !important;
    }

    .case-img {
        width: 90vw !important;
        height: 70vw !important;
        max-height: 220px;
    }

    .case-item-title {
        font-size: 18px;
        line-height: 22px;
    }

    .case-text div {
        font-size: 12px;
        line-height: 16px;
    }

    :deep(.case-carousel .el-carousel__item--card.is-active) {
        transform: translateX(35px) !important;
    }
}


/* 全代码双抬头省心代理样式 */
.agent-section {
    margin-top: 100px ;
    opacity: 0;
    transform: translateY(50px);
    transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.agent-section.slide-up {
    opacity: 1;
    transform: translateY(0);
}

.agent-title {
    font-size: 40px;
    text-align: center;
}

.agent-en {
    font-size: 20px;
    text-align: center;
}

.agent-main {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 50px;
    margin: 50px auto;
}

.agent-card {
    display: flex;
    flex-direction: column;
    width: 300px;
}

.agent-column {
    display: flex;
    flex-direction: column;
    width: 400px;
    height: auto;
    justify-content: center;
    border-radius: 8px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
    overflow: hidden;
}

.agent-img {
    width: 400px;
    height: 200px;
    object-fit: cover;
}

.agent-t {
    margin: 5px 15px;
    font-size: 30px;
    text-align: start;
    font-weight: 700;
    color: #000000;
}

.agent-s {
    margin: 5px 15px;
    font-size: 22px;
    font-weight: 400;
    color: #000000;
    text-align: start;
}

@media (max-width: 768px) {
    .agent-section {
        margin-top: 40px;
    }
    .agent-title {
        font-size: 28px;
    }

    .agent-en {
        font-size: 18px;
    }

    .agent-t {
        font-size: 20px;
    }

    .agent-s {
        font-size: 16px;
    }

    .agent-main {
        flex-direction: column;
        align-items: center;
        margin-top: 15px;
    }

    .agent-column {
        width: 85vw;
    }

    .agent-img {
        width: 85vw;
        height: 180px;
    }

    .agent-section {
        padding: 0px;
    }
}

/* 服务流程样式 */
.server-main {
    margin-top: 90px;
    width: 100%;
    height: 300px;
}

.server-title {
    font-size: 40px;
    text-align: center;
}

.server-en {
    font-size: 20px;
    text-align: center;
}

.server-conter {
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.server-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    opacity: 0;
    /* 初始状态隐藏 */
    transform: translateY(50px);
    /* 初始位置在下方 */
    transition: all 0.6s ease-out;
}

.server-card.slide-up {
    opacity: 1;
    /* 激活状态显示 */
    transform: translateY(0);
    /* 回到原位 */
}

.server-card.slide-up:not(.delay-1):not(.delay-2):not(.delay-3):not(.delay-4):not(.delay-5):not(.delay-6):not(.delay-7) {
    transition-delay: 0s;
}

.server-card.slide-up.delay-1 {
    transition-delay: 0.1s;
}

.server-card.slide-up.delay-2 {
    transition-delay: 0.2s;
}

.server-card.slide-up.delay-3 {
    transition-delay: 0.3s;
}

.server-card.slide-up.delay-4 {
    transition-delay: 0.4s;
}

.server-card.slide-up.delay-5 {
    transition-delay: 0.5s;
}

.server-card.slide-up.delay-6 {
    transition-delay: 0.6s;
}

.server-card.slide-up.delay-7 {
    transition-delay: 0.7s;
}

.server-icon {
    width: 90px;
    height: 90px;
    opacity: 0;
    /* 初始状态隐藏 */
    transform: translateY(50px);
    /* 初始位置在下方 */
    transition: all 0.6s ease-out;
}

.server-icon.slide-up {
    opacity: 1;
    /* 激活状态显示 */
    transform: translateY(0);
    /* 回到原位 */
}

/* 让图标和文字同时出现，不需要额外延迟 */
.server-icon.slide-up {
    transition-delay: 0s;
}

.server-icon.slide-up.delay-2 {
    transition-delay: 0.1s;
    /* 与对应的卡片保持一致 */
}

.server-icon.slide-up.delay-4 {
    transition-delay: 0.2s;
    /* 与对应的卡片保持一致 */
}

.server-icon.slide-up.delay-6 {
    transition-delay: 0.3s;
    /* 与对应的卡片保持一致 */
}

.server-text {
    margin-top: 20px;
    font-size: 20px;
    font-weight: 500;
    opacity: 0;
    /* 初始状态隐藏 */
    transform: translateY(50px);
    /* 初始位置在下方 */
    transition: all 0.6s ease-out;
}

.server-text.slide-up {
    opacity: 1;
    /* 激活状态显示 */
    transform: translateY(0);
    /* 回到原位 */
}

/* 文字和图标应该同时出现，不需要额外延迟 */
.server-text.slide-up {
    transition-delay: 0s;
}

.server-text.slide-up.delay-1 {
    transition-delay: 0.1s;
    /* 与对应的卡片保持一致 */
}

.server-text.slide-up.delay-2 {
    transition-delay: 0.2s;
    /* 与对应的卡片保持一致 */
}

.server-text.slide-up.delay-3 {
    transition-delay: 0.3s;
    /* 与对应的卡片保持一致 */
}

.server-text.slide-up.delay-4 {
    transition-delay: 0.4s;
    /* 与对应的卡片保持一致 */
}

.server-text.slide-up.delay-5 {
    transition-delay: 0.5s;
    /* 与对应的卡片保持一致 */
}

.server-text.slide-up.delay-6 {
    transition-delay: 0.6s;
    /* 与对应的卡片保持一致 */
}

.server-text.slide-up.delay-7 {
    transition-delay: 0.7s;
    /* 与对应的卡片保持一致 */
}

@media (max-width: 768px) {
    .server-main{
        margin-top: 30px;
    }
    .server-title {
        font-size: 28px;
    }
    .server-en{
        font-size: 16px;
    }
    .server-text {
        font-size: 16px;
    }
    .server-icon{
        width: 90px;
        height: 60px;
    }
    
    /* 移动端滑动布局 */
    .server-conter {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        overflow-x: auto;
        padding: 20px 10px;
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
        align-items: baseline;
    }
    
    .server-conter::-webkit-scrollbar {
        display: none; /* Chrome, Safari, Opera */
    }
    
    .server-card {
        flex: 0 0 auto;
        min-width: 120px;
        margin-right: 20px;
        padding: 10px;
    }
    
    .server-icon {
        width: 60px;
        height: 60px;
    }
    
    .server-text {
        font-size: 14px;
        margin-top: 10px;
        text-align: center;
        white-space: nowrap;
    }
}

@media (max-width: 480px) {
    .server-text {
        font-size: 12px;
    }
    
    .server-icon {
        width: 50px;
        height: 50px;
    }
    
    .server-card {
        min-width: 100px;
        margin-right: 15px;
    }
}

/* 活动咨询板块样式 */
.activity-content {
    margin-top: 70px;
    padding-bottom: 100px;
}

.activity-title {
    font-size: 40px;
    text-align: center;
}

.activity-en {
    font-size: 20px;
    text-align: center;
}

.activity-card {
    display: flex;
    justify-content: center;
    border-radius: 30px;
    max-width: 1100px;
    margin: 50px auto 0px auto;
    border: 2px solid #ece7e7;
    background-color: #fdfeff;
    transition: opacity 1s ease-in-out;
    opacity: 0;
    overflow: hidden;
}

.activity-card.active {
    opacity: 1;
    animation: fadeIn 1s ease-in-out;
}

.activity-card.transitioning {
    opacity: 0;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.activity-img {
    width: 600px;
    height: 400px;
    object-fit: cover;
}

.activity-text {
    padding: 40px;
    text-align: start;
    color: #1a1a1a;
}

.activity-h1 {
    font-size: 30px;
}

.activity-des {
    font-size: 20px;
    margin-top: 20px;
}

/* 活动资讯模块移动端适配 */
@media (max-width: 768px) {
    .activity-content {
        margin: 0px 0;
        padding-bottom: 50px;
    }

    .activity-title {
        font-size: 28px;
    }

    .activity-en {
        font-size: 16px;
    }

    .activity-main {
        max-width: 90%;
        padding: 0px 30px 30px 30px;
    }

    .activity-card {
        border-radius: 20px;
        flex-direction: column;
    }

    .activity-img {
        width: 100%;
        height: 250px;
        margin-bottom: 15px;
        border-radius: 10px;
        /* 移动端圆角调整 */
    }

    .activity-text {
        padding: 10px;
        width: 99%;
    }

    .activity-h1 {
        font-size: 24px;
    }

    .activity-des {
        font-size: 16px;
        margin-top: 15px;
    }
}

@media (max-width: 480px) {
    .activity-content {
        margin-top: 0;
        padding: 20px 0;
    }

    .activity-title {
        font-size: 24px;
    }

    .activity-en {
        font-size: 14px;
    }

    .activity-card {
        margin: 20px auto;
        border-radius: 15px;
    }

    .activity-img {
        height: 200px;
        margin-bottom: 10px;
    }

    .activity-text {
        padding: 10px;
        width: 95%;
    }

    .activity-h1 {
        font-size: 20px;
    }

    .activity-des {
        font-size: 14px;
        margin-top: 10px;
    }
}

/* 出海企业专项资源服务样式 */
.specialized-section {
    margin: 100px auto 0px auto;
    max-width: 1200px;
    height: 800px;
    opacity: 0;
    transform: translateY(50px);
    transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.specialized-section.slide-up {
    opacity: 1;
    transform: translateY(0);
}

.specialized-title {
    font-size: 40px;
    text-align: center;
}

.specialized-en {
    margin: 20px 0px;
    font-size: 20px;
    text-align: center;
}

.hover-content-section {
    padding: 50px 0;
    max-width: 1200px;
    margin: 0 auto;
    height: auto;
}

.section-title {
    font-size: 40px;
    text-align: center;
    margin-bottom: 10px;
}

.section-en {
    font-size: 20px;
    text-align: center;
    margin-bottom: 40px;
}

.divier-column {
    margin: 20px auto;
    border: 1px solid #bccae5;
    width: 200px;
}

/* 导航按钮样式 */
.nav-buttons {
    display: flex;
    justify-content: center;
    gap: 30px;
    margin-bottom: 40px;
}

.nav-button {
    padding: 15px 30px;
    background-color: #f0f4f9;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 24px;
    font-weight: 500;
    color: #666;
    border: 2px solid transparent;
    text-align: center;
}

.nav-button:hover,
.nav-button.active {
    background-color: #2a82e4;
    color: white;
    transform: translateY(-3px);
    box-shadow: 0 4px 12px rgba(42, 130, 228, 0.3);
}

/* 内容区域样式 */
.content-area {
    position: relative;
}

.content-item {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    opacity: 0;
    overflow: hidden;
    border: 2px solid #e6e9ef;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border-radius: 12px;
    transform: translateY(20px);
    transition: all 0.4s ease;
    display: flex;
    flex-direction: column;
}

.content-item.active {
    opacity: 1;
    transform: translateY(0);
    z-index: 1;
}

.content-title {
    font-size: 44px;
    font-weight: 600;
    color: #2a82e4;
    margin-bottom: 15px;
    text-align: center;
}

.content-main {
    display: flex;
    flex-direction: row;
}

.content-description {
    font-size: 18px;
    color: #555;
    line-height: 1.6;
    margin-bottom: 25px;
    text-align: center;
}

.content-img {
    width: 700px;
    height: auto;
    object-fit: cover;
}

.content-details {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    flex-grow: 1;
    padding: 48px 0 0 54px;
    color: #1a1a1a;
}

.content-detail {
    padding: 12px 15px;
}

.detail-icon {
    width: 24px;
    height: 24px;
    background-color: #2a82e4;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    font-size: 14px;
}

.detail-text {
    font-size: 24px;
    color: #333;
}

@media (max-width: 768px) {
    .specialized-section {
        margin-top: 40px;
    }
    .hover-content-section{
        padding: 20px 0;
    }
    .specialized-title {
        font-size: 28px;
    }

    .specialized-en {
        font-size: 18px;
    }

    .nav-buttons {
        display: grid;
        grid-template-columns: repeat(2, 0.5fr);
        gap: 10px;
    }

    .nav-button {
        padding: 5px 0px;
        font-size: 16px;
    }

    .content-item {
        align-items: center;
        border: none;
        box-shadow: none;
        border-radius: 1px;
    }

    .content-main {
        width: 90vw;
        flex-direction: column;
        overflow: hidden;
        border: 2px solid #e6e9ef;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
        border-radius: 12px;
    }

    .content-details {
        padding: 10px 0px 0px 0px;
        background-color: #eef5ff;
    }

    .content-title {
        margin: 10px 0px 0px 20px;
        font-size: 28px;
        font-weight: 600;
    }

    .detail-text {
        font-size: 16px;
    }

    .content-img {
        width: 100%;
    }
}

@media (max-width: 480px) {
    .content-title{
        font-size: 22px;
    }
    .content-detail{
        padding: 6px 8px;
    }
    .content-details ul{
        margin-block: 0 !important;
    }
    .specialized-section {
        margin-top: 30px;
    }
    .nav-button {
        font-size: 14px;
    }
}

/* 外贸关汇税单证全托管 */
.foreign-content {
    margin-top: 90px;
    opacity: 0;
    transform: translateY(50px);
    transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.foreign-content.visible {
    opacity: 1;
    transform: translateY(0);
}

.foreign-title {
    font-size: 40px;
    text-align: center;
}

.foreign-en {
    margin: 20px 0px;
    font-size: 20px;
    text-align: center;
}

.foreign-card {
    display: flex;
    flex-direction: row;
    margin: 50px auto;
    background-color: #f8f9fa;
    border: 2px solid #fff;
    border-radius: 20px;
    overflow: hidden;
    justify-content: center;
    max-width: 1100px;
}

.foreign-img {
    width: 700px;
    height: auto;
    object-fit: cover;
}

.foreign-card-item {
    display: flex;
    width: 400px;
    flex-direction: column;
    justify-content: center;
    padding: 40px;
}

.foreign-text {
    display: flex;
    align-items: center;
    padding: 25px 0px;
    gap: 20px;
}

.foreign-item-img {
    width: 60px;
    height: 60px;
}

.foreign-text-item {
    font-size: 20px;
    text-wrap: nowrap;
}

.foreign-point {
    margin: 80px auto 0px auto;
    max-width: 1200px;
    height: 800px;
    position: relative;
}

.foreign-point-img {
    width: 240px;
    height: 90px;
}

.foreign-center-img {
    position: relative;
    left: 28%;
    max-width: 100%;
    height: auto;
}

/* 桌面端图片显示 */
.desktop-img {
    display: block;
}

/* 移动端图片隐藏 */
.mobile-img {
    display: none;
}

.foreign-item-title {
    width: 240px;
    height: 84px;
    line-height: 84px;
    font-size: 20px;
    color: #445a9a;
    font-weight: bold;
    background-image: url('https://www.sailortrade.top/imgs/pointbg.webp');
}

.foreign-item-num {
    margin: 0px 30px;
    color: #fff;
}

.foreign-item-des {
    width: 250px;
    height: auto;
    padding-left: 20px;
    line-height: 25px;
    font-size: 14px;
    color: #333;
}

.foreign-item1 {
    position: relative;
    width: 240px;
    height: 200px;
    left: 76px;
    top: -330px;
}

.foreign-item21 {
    position: relative;
    width: 240px;
    height: 200px;
    left: 76px;
    top: -330px;
}

.foreign-item2 {
    position: relative;
    width: 240px;
    height: 200px;
    left: 122px;
    top: -350px;
}

.foreign-item22 {
    position: relative;
    width: 240px;
    height: 200px;
    left: 122px;
    top: -350px;
}

.foreign-item3 {
    position: relative;
    width: 240px;
    height: 200px;
    left: 230px;
    top: -370px;
}

.foreign-item23 {
    position: relative;
    width: 240px;
    height: 200px;
    left: 830px;
    top: -550px;
}

.foreign-item4 {
    position: relative;
    width: 240px;
    height: 200px;
    left: 710px;
    top: -570px;
}

.foreign-item24 {
    position: relative;
    width: 240px;
    height: 200px;
    left: 900px;
    top: -930px;
}

.foreign-item5 {
    position: relative;
    width: 240px;
    height: 200px;
    left: 840px;
    top: -950px;
}

.foreign-item6 {
    position: relative;
    width: 240px;
    height: 200px;
    left: 885px;
    top: -1330px;
}

/* 解决痛点模块移动端适配 */
@media (max-width: 768px) {
    .foreign-content {
        margin: 0;
    }

    .foreign-point {
        margin: 0px auto;
        max-width: 100%;
        height: auto;
        position: relative;
    }

    .foreign-title {
        display: none;
    }

    .foreign-en {
        display: none;
    }

    .divier-column {
        display: none;
    }

    /* 隐藏桌面端图片 */
    .desktop-img {
        display: none;
    }

    /* 显示移动端图片 */
    .mobile-img {
        display: block;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        height: auto;
        margin: 40px 0;
    }

    /* 隐藏所有定位元素 */
    .foreign-item1,
    .foreign-item2,
    .foreign-item3,
    .foreign-item4,
    .foreign-item5,
    .foreign-item6 {
        display: none;
    }
}

@media (max-width: 480px) {
    .foreign-content {
        padding: 20px 0;
    }

    .foreign-title {
        font-size: 24px;
    }

    .foreign-en {
        font-size: 14px;
    }

    .mobile-img {
        width: 100vw;
    }
}

.groupTools {
    position: fixed;
    z-index: 9;
    right: 20px;
    bottom: 45px;
    -webkit-transition: 0.9s all;
    -o-transition: 0.9s all;
    -moz-transition: 0.9s all;
    transition: 0.9s all;
}

.to_top {
    width: 40px;
    height: 40px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15);
    line-height: 40px;
    text-align: center;
    margin-top: 5px;
    cursor: pointer;
    position: relative;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
}

.to_top_img {
    width: 40px;
    height: 40px;
    object-fit: cover;
}
</style>